// extracted by mini-css-extract-plugin
export default {"wrapper":"DialogBox_wrapper__7HDOl","content":"DialogBox_content__SxE9W","footer":"DialogBox_footer__gSjx3"};